import { createSelector } from 'reselect'
import { namespace } from '.'
import { State } from './reducer'

const getState = (state: { [namespace]: State }) => state[namespace]

export const getEnableLTHedge = createSelector(
  [getState],
  (state) => state.settings.enableLTHedge
)

export const getMaxGrids = createSelector(
  [getState],
  (state) => state.settings.maxGrids
)

export const showLTSetting = createSelector(
  [getState],
  (state) => state.settings.showLT
)

export const showTsySetting = createSelector(
  [getState],
  (state) => state.settings.showTsy
)

export const showTOBSetting = createSelector(
  [getState],
  (state) => state.settings.showTOB
)

export const showCheckoutSetting = createSelector(
  [getState],
  (state) => state.settings.showCheckout
)

export const getIcebergThreshold = createSelector(
  [getState],
  (state) => state.settings.icebergThreshold
)

export const getWebSettingsLoaded = createSelector(
  [getState],
  (state) => !state.settings.isLoading
)

export const getExposureDurationDefault = createSelector(
  [getState],
  (state) => state.settings.exposureDurationDefault
)

export const getExposureDurationValues = createSelector([getState], (state) => {
  return state.settings.exposureDurationValues.map((value) => ({
    label: value < 60 ? `${value} sec` : `${value / 60} min`,
    value
  }))
})

export const getEnableRFQ = createSelector(
  [getState],
  (state) => state.settings.enableRFQ
)

export const getListTradingMaxRows = createSelector([getState], (state) => {
  const value = state.settings.listTradingMaxRows
  return typeof value === 'number' && value > 0 ? value : 200
})

export const getCanSeeSystemParamEditor = createSelector(
  [getState],
  (state) => state.userPermissions.canSeeSystemParamEditor
)

export const getCanEditTiers = createSelector(
  [getState],
  (state) => state.userPermissions.canEditTiers
)

export const getCanMarkRestricted = createSelector(
  [getState],
  (state) => state.userPermissions.canMarkRestricted
)

export const getCanForceCancel = createSelector(
  [getState],
  (state) => state.userPermissions.canForceCancel
)

export const getIsAdmin = createSelector(
  [getState],
  (state) => state.userPermissions.isAdmin
)

export const getHasTradingRights = createSelector(
  [getState],
  (state) => state.userPermissions.hasTradingRights
)

export const getCanEnterPassiveOrders = createSelector(
  [getState],
  (state) => state.userPermissions.canEnterPassiveOrders
)

export const getAllowOrderEntry = createSelector(
  [getState],
  (state) =>
    state.userPermissions.hasTradingRights &&
    state.userPermissions.canEnterPassiveOrders
)

export const getIsBroker = createSelector(
  [getState],
  (state) => state.userPermissions.isBroker
)

// brokers function as clients today but in the future
// will be able to act on behalf of clients
export const getIsAdminOrBroker = createSelector(
  [getIsAdmin, getIsBroker],
  (isAdmin, isBroker) => isAdmin || isBroker
)
